import { useIntl } from 'react-intl';
import { DeliveryReceiptRequestDto, CartItemDto, usePrintDirectReceipt } from '@ordr-as/ordr-service-types/epos';
import PrintForm from '../../../../components/ReceiptForm/PrintForm';
import { useLocation } from '../../../../context/LocationContext';
import { useCheckout } from '../../../../context/CheckoutContext';
import { useCartStore } from '../../../../context/cart/CartStore';

interface Props {
  customerName: string | undefined;
  referencePerson: string | undefined;
}

const PrintInvoiceDeliveryReceipt = (props: Props) => {
  const { customerName, referencePerson } = props;
  const { location } = useLocation();
  const { formatMessage } = useIntl();
  const { orderLines } = useCartStore((state) => ({
    orderLines: state.cart.orderLines,
  }));

  const { deliveryMethod } = useCheckout();
  const { mutate: printDeliveryReceipt, isPending } = usePrintDirectReceipt();

  const handlePrint = (placementId: number) => {
    const cartItems: CartItemDto[] = orderLines.map((orderLine) => ({
      itemVariantId: orderLine.itemVariantId,
      menuSectionId: orderLine.menuSectionId ?? '',
      sectionProductId: orderLine.sectionProductId ?? '',
      price: orderLine.price,
      quantity: orderLine.quantity,
      openPrice: orderLine.openPrice ?? false,
      deliveryType: deliveryMethod.type,
      options: orderLine.options.map((option) => ({
        optionId: option.id ?? '',
        quantity: option.quantity,
      })),
    }));

    const deliveryReceiptRequest: DeliveryReceiptRequestDto = {
      caller: 'epos',
      invoice: true,
      orderNumbers: [],
      locationId: location.id,
      locationIds: [location.id],
      cartItems: cartItems,
      customerName: customerName,
      customerReferencePerson: referencePerson,
    };
    printDeliveryReceipt({
      orderReference: crypto.randomUUID(),
      placementId: placementId,
      data: deliveryReceiptRequest,
    });
  };

  return (
    <PrintForm
      handlePrint={handlePrint}
      isDisabled={isPending}
      buttonLabel={formatMessage({ id: 'generic.printBill' })}
    />
  );
};

export default PrintInvoiceDeliveryReceipt;
